import { Button, TextInput } from '@mantine/core';
import React from 'react';
import styled from 'styled-components';

interface Props {
    email: string;
    onEmailChange: (email: string) => void;
    onSubmit: () => void;
    loading: boolean;
    disabled?: boolean;
}

export const EmailEntryForm = ({ email, onEmailChange, onSubmit, loading, disabled }: Props) => {

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!email || loading || disabled) return;
        onSubmit();
    };

    return <Form onSubmit={handleSubmit}>
        <TextInput
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={e => onEmailChange(e.currentTarget.value)}
            autoFocus
            disabled={loading || disabled}
            w="100%"
            mb="md"
        />
        <Button
            type="submit"
            disabled={disabled}
            loading={loading}
            color="primary"
            size="sm"
            fullWidth
        >
            Continue
        </Button>
    </Form>;
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;
